import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import providersMaster from '@/assets/recommend/providers.json'
import {
  wgFormatLocation,
  wgFormatSalary,
  wgGetStationName
} from '@/utils/workgate-format'

type Detail = Record<string, any> | null

interface ProviderMaster {
  label?: string
  privacy_url?: string
  apply_label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendJobDetailPanel',
  props: {
    detail: { default: null }
  },
  emits: ["apply"],
  setup(__props: any) {

const props = __props as { detail: Detail };

/**
 * おすすめ求人の詳細パネル（ダイアログ Step 2）。
 *
 * WorkgateDialog から切り出した表示専用コンポーネント。
 * 取得・応募・状態遷移は親が持ち、ここは detail を描画して apply を上げるだけ。
 */




const detailProvider = computed(
  () => (props.detail && props.detail.provider) || 'workgate'
)
const master = computed<ProviderMaster>(
  () =>
    (providersMaster as Record<string, ProviderMaster>)[detailProvider.value] ||
    {}
)

const detailProviderLabel = computed(
  () => master.value.label || detailProvider.value
)
const detailProviderPrivacyUrl = computed(() => master.value.privacy_url || '')
const detailApplyLabel = computed(
  () => master.value.apply_label || '履歴書を提出'
)

// 応募APIが止まっている提供元（本番の Carat）と応募済みでは応募ボタンを出さない
const detailApplyEnabled = computed(() => {
  const d = props.detail
  return !d || (d.apply_enabled !== false && !d.is_applied)
})

function getEmployName(item: Detail): string {
  if (!item) return '-'
  if (item.employ_name) return item.employ_name
  if (item.employ && item.employ.name) return item.employ.name
  return '-'
}

function getJobName(item: Detail): string {
  if (!item) return '-'
  if (item.job_name) return item.job_name
  if (item.job && item.job.name) return item.job.name
  return '-'
}

function formatCompanyAddress(item: Detail): string {
  if (!item) return '-'
  // Carat は flat な1本の文字列、Workgate は company.location に分かれている
  if (item.company_address) return item.company_address
  if (!item.company) return '-'
  const loc = item.company.location
  if (!loc) return '-'
  const parts = []
  if (loc.pref) parts.push(loc.pref)
  if (loc.city) parts.push(loc.city)
  if (loc.address) parts.push(loc.address)
  return parts.length > 0 ? parts.join('') : '-'
}

function getDetailImages(item: Detail): string[] {
  if (!item) return []
  const imgs: string[] = []
  if (item.image1) imgs.push(item.image1)
  if (item.image2) imgs.push(item.image2)
  return imgs
}

return { __sfc: true,props, detailProvider, master, detailProviderLabel, detailProviderPrivacyUrl, detailApplyLabel, detailApplyEnabled, getEmployName, getJobName, formatCompanyAddress, getDetailImages, wgFormatLocation, wgFormatSalary, wgGetStationName }
}

})